__turbopack_context__.v({
  "descriptionStyles": "entityCategoryItem-module-scss-module__L4zADa__descriptionStyles",
  "deviceGroupDescriptionStyles": "entityCategoryItem-module-scss-module__L4zADa__deviceGroupDescriptionStyles",
  "deviceGroupStyles": "entityCategoryItem-module-scss-module__L4zADa__deviceGroupStyles",
  "dropdownStyles": "entityCategoryItem-module-scss-module__L4zADa__dropdownStyles",
  "fixedHoverAnimationContainer": "entityCategoryItem-module-scss-module__L4zADa__fixedHoverAnimationContainer",
  "imageContainer": "entityCategoryItem-module-scss-module__L4zADa__imageContainer",
  "linkStyles": "entityCategoryItem-module-scss-module__L4zADa__linkStyles",
  "mainWrapper": "entityCategoryItem-module-scss-module__L4zADa__mainWrapper",
  "mediumVariantStyles": "entityCategoryItem-module-scss-module__L4zADa__mediumVariantStyles",
  "noHoverAnimation": "entityCategoryItem-module-scss-module__L4zADa__noHoverAnimation",
  "rightAlignedImageStyles": "entityCategoryItem-module-scss-module__L4zADa__rightAlignedImageStyles",
  "smallVariantStyles": "entityCategoryItem-module-scss-module__L4zADa__smallVariantStyles",
  "textContainer": "entityCategoryItem-module-scss-module__L4zADa__textContainer",
  "titleStyles": "entityCategoryItem-module-scss-module__L4zADa__titleStyles",
});
